import React from 'react';

const WineSubmissionPage = React.lazy(() => import('pages/wine-submissions'));
const WineSubmissionVendorEditPage = React.lazy(() => import('pages/wine-submissions/vendor-view/edit'));
const WineSubmissionVendorSubmitNewWSPage = React.lazy(() => import('pages/wine-submissions/vendor-view/edit'));
const WineSubmissionAdminEditPage = React.lazy(() => import('pages/wine-submissions/admin-view/edit'));
const WineSubmissionAdminSubmitNewWSPage = React.lazy(() => import('pages/wine-submissions/admin-view/edit'));

export const definitions = [
  {
    index: true,
    policies: [
      { resource: 'wineSubmissions', action: 'adminView' },
      { resource: 'wineSubmissions', action: 'vendorView' }
    ],
    component: <WineSubmissionPage />
  },
  {
    path: 'vendor/edit/:productID',
    policies: [{ resource: 'wineSubmissions', action: 'vendorModify' }],
    component: <WineSubmissionVendorEditPage />
  },
  {
    path: 'vendor/new',
    policies: [{ resource: 'wineSubmissions', action: 'vendorModify' }],
    component: <WineSubmissionVendorSubmitNewWSPage />
  },
  {
    path: 'admin/edit/:productID',
    policies: [{ resource: 'wineSubmissions', action: 'adminModify' }],
    component: <WineSubmissionAdminEditPage />
  },
  {
    path: 'admin/new',
    policies: [{ resource: 'wineSubmissions', action: 'adminModify' }],
    component: <WineSubmissionAdminSubmitNewWSPage />
  }
];
